/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Col,
  Form,
  Switch,
  Alert,
  Input,
  InputNumber,
  message,
  Radio,
  Row,
  Select,
  TreeSelect,
  Upload,
  Slider,
  Tooltip,
  Icon,
  TimePicker
} from 'antd';
import { Button, modal } from 'icsoc-antd-ex';
import IconFont from 'Components/common/iconFont';
import tListActions from 'Actions/taskManage/list';
import tSoundMarket from 'Actions/systemSetting/soundMarket';
import config from './config';
import './index.less';
import CustomColumn from './CustomColumn';
import moment from "moment";
// const {Panel} = Collapse;

// import reducer from 'redux-devtools-dock-monitor/lib/reducers';

const { ModalSize, modalTips } = modal;
const FormItem = Form.Item;
const { Option } = Select;
const formItemLayout = { labelCol: { span: 5 }, wrapperCol: { span: 19 } };
// const inFormItemLayout = { labelCol: { span: 5 }, wrapperCol: { span: 19 } };

class EditModal extends Component {
  constructor(props) {
    super(props);
    const {editModalData:{recallDelayMinute}} = this.props
    this.state = {
      confirmLoading: false, // 编辑弹框确认loading
      importId: undefined,
      fileName: undefined,
      encryptTokenVal: '',// 加密token
      phoneOptionsList: [],
      // recallDelayMinuteMap:[], 

      recallDelayMinuteMap:Array.from(String(recallDelayMinute).includes(',')?String(recallDelayMinute).split(','):[recallDelayMinute]) 
    };
    this.child = null;
  }

  componentWillMount() {
    this.customize = localStorage.getItem('customize') || '';
    
  }

  componentDidMount() {
    const {editModalData:{recallDelayMinute,recallDelayType},form:{setFieldsValue}} = this.props
    this.setState({
      recallDelayMinuteMap:Array.from(String(recallDelayMinute).includes(',')?String(recallDelayMinute).split(','):[recallDelayMinute]) 
    },()=>{
      const {recallDelayMinuteMap} = this.state
      setFieldsValue({
        recallDelayMinuteMap,
      })
    })
    const { listActions } = this.props;
    // 获取主叫号码下拉框+工作时间下拉框
    // const {form} = this.props;
    // listActions.getPhoneOptions(form.getFieldValue('deptIdList'));

    listActions.getPhoneOptions().then(res => {
      if (res.payload.code == 200) {
        const { id = '', phone = '', riskCheck } = this.props.editModalData;
        res.payload.data.unshift({ name: '自定义', id: '-1', is_selected: 0 })
        if (id && phone) {
          if (riskCheck && riskCheck <= 0) {
            res.payload.data.map(item => {
              if (item.id != '-1') {
                item.is_selected = 1
              }
            })
          } else {
            const phoneArr = phone.split(',');
            if (phoneArr.includes('auto')) {
              res.payload.data.map(item => {
                if (item.id != 'auto') {
                  item.is_selected = 1
                }
              })
            } else {
              res.payload.data.map(item => {
                if (item.id == 'auto' || item.id == '-1') {
                  item.is_selected = 1
                }
              })
            }
          }
        } else {
          res.payload.data.map(item => {
            item.is_selected = 0;
          })
        }
        this.setState({ phoneOptionsList: res.payload.data });
      }
    }); // 获取手机号码
    listActions.getWorkTimeOptions();
    listActions.getCustomizeSmgTemplates();
    const user = window.localStorage.getItem('user') || '{}';
    const vccId = JSON.parse(user).profile?.vcc_id;
    listActions.queryDeptTree(vccId);
    // const {
    //   editModalData: {id},
    // } = this.props;
    // if (id) {
    // 修改操作，初始化全部话术
    listActions.getStrategyOptions(['ALL']);
    // }
  }

  // 校验任务名称
  checkTaskName = (rule, value, callback) => {
    const valueTrim = (value && value.replace(/^\s+|\s+$/g, '')) || '';

    if (valueTrim !== '') {
      if (!/^[a-zA-Z0-9_\u4e00-\u9fa5]{1,60}$/g.test(valueTrim)) {
        callback('任务名称只能最多由60个数字、字母、汉字或下划线组成！');
      }
    }
    callback();
  };

  // 上传
  normFile = e => {
    let fileList = [];

    if (Array.isArray(e)) {
      fileList = [...e];
    } else {
      fileList = [...e.fileList];
    }
    fileList = fileList.slice(-1); // 限制只能上传一个文件

    const {
      status,
      name = '',
      response = {},
      response: {
        code = '',
        data: { importId = undefined } = {},
        error = '上传失败',
      } = {},
    } =
      fileList[0] || {};

    if (status !== 'uploading') {
      let fileName = name;

      if (status === 'error') {
        fileList = [];
        fileName = '';
        message.error(error);
      }

      if (status === 'done' && Object.keys(response).length !== 0) {
        if (parseInt(code, 10) === 200) {
          this.handleHasResponse(response, name);
        } else {
          fileList = [];
          fileName = '';
          message.error(error);
        }
      }

      this.setState({
        fileName,
        importId,
      });
    }

    return fileList;
  };

  // 当上传之后接口返回200
  handleHasResponse = (response, name) => {
    const { form: { setFieldsValue = () => { } } = {} } = this.props;
    const {
      data: { failed = [], dup = [], total = 0, importId = undefined } = {},
    } =
      response || {};
    // 错误数
    const failedNum =
      Array.isArray(failed) && failed.length > 0 ? failed.length : 0;
    // 重复数
    const dupNum = Array.isArray(dup) && dup.length > 0 ? dup.length : 0;
    // 成功数
    const successNum = total - failedNum - dupNum;
    const failList = failed.concat(dup);
    let modalType = 'default';
    let title = '提示';
    let content = '';
    let okText = '确认导入';
    let cancelText = '取消导入';
    let modalOnOk = () => {
      this.setState({
        importId,
        fileName: name,
      });
    };
    const modalOnCancel = () => {
      setFieldsValue({
        upload: [],
      });
    };

    // 有错误数或者重复数
    if (failedNum || dupNum) {
      content = (
        <div>
          <p>
            共导入
            <span className="primary-color"> {total} </span>
            条数据，正确数据
            <span className="success-color"> {successNum} </span>
            条，错误数据
            <span className="error-color"> {failedNum} </span>
            条，重复数据
            <span className="error-color"> {dupNum} </span>
            条。
          </p>
          <div
            style={{
              maxHeight: '180px',
              overflowY: 'auto',
            }}>
            {Array.isArray(failList) && failList.length > 0
              ? failList.map(({ name }, index) => <p key={index}>{name}。</p>)
              : null}
          </div>
        </div>
      );

      if (successNum === 0) {
        modalType = 'simple';
        title = '导入的表格无有效数据';
        content = '';
        okText = '';
        cancelText = '';
        modalOnOk = () => {
          setFieldsValue({
            upload: [],
          });
        };
      }

      modalTips({
        centered: true,
        type: 'error',
        mode: modalType,
        title,
        content,
        okText,
        cancelText,
        onOk: modalOnOk,
        onCancel: modalOnCancel,
      });
    }
  };

  // 点击确定
  handleSubmit = (customColumns) => {
    const {
      editModalData: { id },
      form: { validateFields },
      setEditModalVisible,
      listActions,
      getTableList,
      searchData,
      pageStatus,
    } = this.props;

    validateFields((err, values) => {
      if (!err) {
        const {
          taskName,
          callNumber,
          dragger,
          recallTimes,
          recallDelayType,
          recallDelayMinuteMap,
          deptIdList = [],
          callbackUrl,
          callNumberCustom,
          extColsFlag,
          callCheckDay,
          ...otherValues
        } =
          values || {};
        if(callCheckDay){
          otherValues.callCheckDay = moment(callCheckDay).hours() * 60 + moment(callCheckDay).minutes()
        }
        const { importId, fileName ,} = this.state;
        let params = {};
        if (id) {
          // 编辑
          params = {
            ...otherValues,
            extColsFlag: extColsFlag?1:0,
            extColsContent: customColumns?customColumns:'',
            id,
            taskName: taskName && taskName.trim(),
            callNumber: callNumber && callNumber.join(','),
            importId: -1,
            recallTimes: recallTimes || 0,
            recallDelayType,
            recallDelayMinute: !recallDelayMinuteMap?'': recallDelayMinuteMap.length>1?recallDelayMinuteMap.join(',') :recallDelayMinuteMap[0],
            deptIdList: deptIdList || [],
            callbackUrl: callbackUrl || '',
          };
        } else {
          // 新增
          params = {
            ...otherValues,
            extColsFlag: extColsFlag?1:0,
            extColsContent: customColumns?customColumns:'',
            taskName: taskName && taskName.trim(),
            callNumber: callNumber && callNumber.join(','),
            importId: importId || '',
            fileName: fileName || '',
            recallTimes: recallTimes || 0,
            recallDelayType,
            recallDelayMinute: !recallDelayMinuteMap?'': recallDelayMinuteMap.length>1?recallDelayMinuteMap.join(',') :recallDelayMinuteMap[0],
            deptIdList: deptIdList || [],
            callbackUrl: callbackUrl || '',
          };
        }
        if (callNumber.includes('-1')) {
          params.callNumberCustom = callNumberCustom.join(',')
        }
        this.setState({
          confirmLoading: true,
        });
        listActions
          .editTask(params)
          .then(res => {
            const { payload: { code } = {} } = res || {};

            if (parseInt(code, 10) === 200) {
              setEditModalVisible();
              message.success(`${id ? '修改' : '创建'}任务成功！`);
              getTableList({
                ...searchData,
                ...pageStatus,
              });
            }
          })
          .finally(() => {
            this.setState({
              confirmLoading: false,
            });
          });
      }
    });
  };

  // 语速 语调 音量
  onChangeSetting = (val, type) => {
    const { form: { setFieldsValue } } = this.props;
    switch (type) {
      case 'speech':
        setFieldsValue({ ttsSpeechRate: val });
        break;
      case 'tone':
        setFieldsValue({ ttsTone: val });
        break;
      case 'volume':
        setFieldsValue({ ttsVolume: val });
        break;
      default:
      // break;  
    }
  }

  // 试听播放
  audioPlay = () => {
    const { SoundMarketActions } = this.props;
    const { getFieldsValue } = this.props.form;
    const { ttsSpeechRate, ttsTone, ttsVolume, ttsVoiceName } = getFieldsValue();
    if (ttsSpeechRate > 500 || ttsSpeechRate < -500) {
      return message.warning('语速请输入0.5~2范围之间的数字！');
    }
    if (ttsTone > 500 || ttsTone < -500) {
      return message.warning('语调请输入-500~500范围之间的数字！');
    }
    if (ttsVolume > 100 || ttsVolume < 0) {
      return message.warning('请输入0~100范围之间的数字！');
    }
    const params = {
      txt: '您好，我是您的语音机器人，很高兴为您服务，请问有什么可以帮您？',
      ttsVoiceName, ttsVolume,
      ttsSpeechRate, ttsPitchRate: ttsTone
    }
    this.audio && this.audio.pause();
    SoundMarketActions.getMarketUrl(params).then(res => {
      if (res.payload.code == 200) {
        if (this.audio) {
          this.audio.src = `${res.payload.data.voiceUrl}?time=${new Date().getTime()}`;
          this.audio.play();
        }
      }
    })
  }

  getMoment = (val) => {
    let date = new Date();
    date.setHours(val / 60, val % 60, 0)
    return new moment(date)
  }

  // 是否加密
  generateToken = (e) => {
    if (e.target.value == 1) {
      this.getRandomToken();
    }
  }

  // 获取token
  getRandomToken = () => {
    const { listActions } = this.props;
    listActions.getRandomToken().then(res => {
      if (res.payload.code == 200) {
        this.props.form.setFieldsValue({ encryptToken: res.payload.data });
      }
    })
  }

  onChange = value => {
    const { listActions } = this.props;
    // listActions.getPhoneOptions(value);
    // listActions.getPhoneOptions([]);// 无关联
    const { editModalData } = this.props;
    editModalData.phone = '';
    const { form } = this.props;
    // form.resetFields('callNumber');
    const {
      editModalData: { id },
    } = this.props;
    if (!id) {
      form.resetFields('wordStrategyId');
      listActions.getStrategyOptions(value);
    }
  };

  changeCallNumber = (val) => {
    const { getFieldsValue } = this.props.form;
    const { phoneOptionsList } = this.state;
    if (val.length > 0) {
      if (val.includes('auto')) {
        phoneOptionsList.map(item => {
          if (item.id != 'auto') {
            item.is_selected = 1
          }
        })
      } else if (val.includes('-1')) {
        phoneOptionsList.map(item => {
          if (item.id != '-1') {
            item.is_selected = 1
          }
        })
      } else {
        phoneOptionsList.map(item => {
          if (item.id == 'auto' || item.id == '-1') {
            item.is_selected = 1
          }
        })
      }
    } else {
      phoneOptionsList.map(item => {
        item.is_selected = 0
      })
    }
    this.setState({ phoneOptionsList })
  }

 //重呼次数变化
  changeRecallTimes = (v)=>{
    const {form: { getFieldValue,setFieldsValue }} = this.props
    let type =getFieldValue('recallDelayType')
    let arr =[]
    // debugger
    if(v &&  type== 1){
      for(let i=0;i<v;i++){
        arr.push(0)
      }
      
    }else if(v && !type){
      arr = [0]
    }
    this.setState({
      recallDelayMinuteMap:Array.from(arr)
    },()=>{
      const {recallDelayMinuteMap} = this.state
      setFieldsValue({
        recallDelayMinuteMap,
      })

    })

  }
  //呼叫间隔方式变化
  chageRecallDelayType = (v)=>{
    // debugger
    const {form: { getFieldValue,setFieldsValue }} = this.props
    let long = getFieldValue('recallTimes')
    let arr =[]
    if(v.target.value==0 && long){
        arr = [0]
    }else if(v.target.value == 1 && long){
      for(let i=0;i<long;i++){
        arr.push(0)
      }

    }
    this.setState({
      recallDelayMinuteMap:Array.from(arr)

    },()=>{
      const {recallDelayMinuteMap} = this.state
      setFieldsValue({
        recallDelayMinuteMap,
      })

    })
  }
  onRef = ref => {
    this.child = ref;
  }
  onOk = () => {
    const me = this;
    this.child.handleSubmit(this.handleSubmit.bind(me))
  }

  render() {
    const { confirmLoading, encryptTokenVal ,recallDelayMinuteMap} = this.state;
    // const {listActions} = this.props;
    const {
      wordStrategyIdOptionList = [],
      phoneOptions = [],
      workTimeOptions = [],
      treeData = [],
      editModalData,
      editModalData: {
        id = '',
        taskName = '',
        deptIdList = [],
        wordStrategyId,
        phone,
        workTimeId,
        queueNumber,
        callbackUrl,
        ttsVolume,
        ttsSpeechRate,
        ttsVoiceName,
        smsId,
        status,
        recallTimes =0,
        recallDelayType=0,
        recallDelayMinute,
        recallEvent = 0,
        riskCheck,
        encryptFlag = 0,
        callCheckType = 0,
        checkBeforeCallout = 0,
          checkUrl = '',
          callCheckDay,
        encryptToken = '',
        ttsTone = '',
        monitor = 0,
        extColsFlag = 0,
        customizeCols,
        // batchName = '',
      } = {},
      setEditModalVisible,
      form: { resetFields, getFieldDecorator, getFieldValue },
      // templates,
      getTableList,
      searchData,
      pageStatus,
      toneList,
    } = this.props;
    const phoneArr = phone && phone.split(',');
    let callNumberCustomArr = [];
    let transferPhoneArr =
      phoneArr instanceof Array && phoneArr.length > 0
        ? phoneArr.map(item => String(item))
        : undefined;
    if (riskCheck && riskCheck <= 0) {
      callNumberCustomArr = phoneArr;
      transferPhoneArr = ['-1'];
    }
    const user = window.localStorage.getItem('user') || '{}';
    const authorization = JSON.parse(user).access_token;
   
    const callNumberInitialValue = [];
    const { phoneOptionsList } = this.state;

    // let recallDelayMinuteMap= String(recallDelayMinute).includes(',')?String(recallDelayMinute).split(','):[recallDelayMinute]
    return (
      <ModalSize
        title={`${id ? '编辑' : '创建'}任务`}
        centered
        maskClosable={false}
        visible
        width='700'
        onOk={this.onOk}
        onCancel={() => {
          setEditModalVisible();
          // eslint-disable-next-line eqeqeq
          if (phone == '') {
            getTableList({
              ...searchData,
              ...pageStatus,
            });
          }
        }}
        confirmLoading={confirmLoading}
        afterClose={() => {
          resetFields();
        }}>
        {/* 音频播放器 */}
        <audio ref={c => { this.audio = c; }}>
          Your browser does not support the audio element.
        </audio>
        <Form>
          <FormItem {...formItemLayout} label="任务名称">
            {getFieldDecorator('taskName', {
              initialValue: taskName,
              rules: [
                {
                  validator: this.checkTaskName,
                },
                {
                  required: true,
                  whitespace: true,
                  message: '任务名称不能为空！',
                },
              ],
            })(
              <Input
                placeholder="请输入任务名称"
                maxLength="60"
                disabled={!!id}
              />,
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="选择部门">
            {getFieldDecorator('deptIdList', {
              initialValue: deptIdList || undefined,
            })(
                <TreeSelect
                    style={{ width: '100%' }}
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    treeData={treeData}
                    placeholder="选择部门"
                    onChange={this.onChange}
                    allowClear
                    multiple
                    treeDefaultExpandAll={false}
                />,
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="选择话术">
            {getFieldDecorator('wordStrategyId', {
              initialValue: wordStrategyId || undefined,
              rules: [{ required: true, message: '请选择话术！' }],
            })(
              <Select placeholder="请选择" disabled={status === 1}>
                {Array.isArray(wordStrategyIdOptionList)
                  ? wordStrategyIdOptionList.map(({ id, strategyName }) => (
                    <Option value={id && parseInt(id, 10)} key={id}>
                      {strategyName}
                    </Option>
                  ))
                  : null}
              </Select>,
            )}
          </FormItem>
          <FormItem {...formItemLayout} label="主叫号码">
            {getFieldDecorator('callNumber', {
              initialValue: id ? transferPhoneArr : callNumberInitialValue,
              rules: [
                {
                  required: true,
                  message: '主叫号码不能为空！',
                },
              ],
            })(
              <Select
                placeholder="请选择"
                allowClear
                defaultValue={id ? transferPhoneArr : callNumberInitialValue}
                mode="multiple"
                onChange={this.changeCallNumber}>
                {phoneOptionsList instanceof Array && phoneOptionsList.length
                  ? phoneOptionsList.map(({ name = '', id = '', is_selected = 0 }) => (
                    <Option value={String(id)} key={id} disabled={is_selected == 1}>
                      {name}
                    </Option>
                  ))
                  : null}
              </Select>,
            )}
          </FormItem>
          {
            getFieldValue('callNumber').includes('-1') ?
              <FormItem {...formItemLayout} label="自定义主叫号码">
                {
                  getFieldDecorator('callNumberCustom', {
                    initialValue: callNumberCustomArr || [],
                    rules: [
                      {
                        required: true,
                        message: '请输入自定义主叫号码',
                      },
                    ],
                  })(
                    <Select
                      className="keywordsContent"
                      mode="tags"
                      style={{ width: '100%' }}
                      dropdownMenuStyle={{ display: 'none' }}
                      tokenSeparators={[',']}
                      placeholder="输入后按Enter键确认"
                    />,
                  )
                }
              </FormItem>
              : null
          }
          {!id ? (
            <React.Fragment>
              <FormItem {...formItemLayout} label="导入客户">
                {getFieldDecorator('upload', {
                  valuePropName: 'fileList',
                  getValueFromEvent: this.normFile,
                  rules: [{ required: true, message: '请导入客户！' }],
                })(
                  <Upload
                    name="file"
                    action="/robot/file/importExcel"
                    headers={{ authorization: `Bearer ${authorization}` }}
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                    <Button>
                      <IconFont type="icon-robotexport" />
                      选择表格
                    </Button>
                  </Upload>,
                )}
              </FormItem>
              <FormItem {...formItemLayout} label=" " colon={false}>
                {this.customize === 'txgg' ? (
                  <a href="/robot/static/templates/template-cus.xlsx" key={1}>
                    <Button type="primary">
                      <IconFont type="icon-robotdownload" />
                      <span>下载模板</span>
                    </Button>
                  </a>
                ) : (
                  <a href="/robot/static/templates/template.xlsx" key={2}>
                    <Button type="primary">
                      <IconFont type="icon-robotdownload" />
                      <span>下载模板</span>
                    </Button>
                  </a>
                )}
              </FormItem>
              {/* <FormItem {...formItemLayout} label="批次名称：">
                {getFieldDecorator('batchName', {
                  initialValue: batchName,
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message: '批次名称不得为空！',
                    },
                  ],
                })(<Input placeholder="请输入批次名称" />)}
              </FormItem> */}
            </React.Fragment>
          ) : null}
          <FormItem {...formItemLayout} label="呼叫时间">
            {getFieldDecorator('workTimeId', {
              initialValue: workTimeId || undefined,
              rules: [{ required: true, message: '请选择呼叫时间！' }],
            })(
              <Select placeholder="请选择">
                {workTimeOptions instanceof Array && workTimeOptions.length
                  ? workTimeOptions.map(({ workName = '', id = '' }) => (
                    <Option value={id} key={id}>
                      {workName}
                    </Option>
                  ))
                  : null}
              </Select>,
            )}
          </FormItem>
          <Form.Item {...formItemLayout} label="并发数">
            {getFieldDecorator('queueNumber', {
              initialValue: queueNumber,
              rules: [{ required: true, message: '请输入并发数！' }],
            })(
              <InputNumber
                placeholder="请输入并发数"
                min={1}
                step={1}
                precision={0}
                style={{ width: '100%' }}
              />,
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="回调地址">
            {getFieldDecorator('callbackUrl', {
              initialValue: callbackUrl,
            })(<Input placeholder="请输入回调地址" />)}
          </Form.Item>
          {/* <FormItem {...formItemLayout} label="挂机短信模板">
            {getFieldDecorator('smsId', {
              initialValue: smsId,
            })(
              <Select placeholder="请选择">
                {templates
                  ? templates.map(item => (
                      <Option value={item.id} key={item.id}>
                        {item.name}
                      </Option>
                    ))
                  : null}
              </Select>,
            )}
          </FormItem> */}
          {/* <FormItem {...formItemLayout} label="路由状态">
            {getFieldDecorator('riskCheck', {
              initialValue: riskCheck || 0,
            })(
              <Radio.Group>
                <Radio value={0}>关闭</Radio>
                <Radio value={1}>开启</Radio>
              </Radio.Group>,
            )}
            <span style={{fontSize: 12, color: '#f63c3c', textAlign: 'right'}}>
              如需开启路由请联系售后确认
            </span>
          </FormItem> */}
          {/* <Collapse className="recallSet">
            <Panel header="重呼设置"> */}
          {/* <div> */}
          <Row>
            <Col span={4}>
              <h1 style={{ fontSize: 16, textAlign: 'right' }}>重呼设置</h1>
            </Col>
            <Col span={6} offset={14} className="desc-word" style={{ textAlign: 'right' }}>
              未接通电话再次呼叫
            </Col>
          </Row>
          <FormItem {...formItemLayout} label="重呼次数">
            {getFieldDecorator('recallTimes', {
              initialValue: recallTimes,
            })(
              <Select placeholder="请选择未接通后的重呼次数" allowClear onChange={this.changeRecallTimes}>
                <Option value={0}>不重呼</Option>
                <Option value={1}>1次</Option>
                <Option value={2}>2次</Option>
                <Option value={3}>3次</Option>
                <Option value={4}>4次</Option>
                <Option value={5}>5次</Option>
              </Select>,
            )}
          </FormItem>
          {getFieldValue('recallTimes') != 0 ?
            <FormItem>
              <FormItem {...formItemLayout} label="呼叫间隔">
                {getFieldDecorator('recallDelayType', {
                  initialValue: recallDelayType || 0,
                })(
                  <Radio.Group onChange={this.chageRecallDelayType}>
                    <Radio value={0}>默认间隔</Radio>
                    <Radio value={1}>自定义间隔</Radio>
                  </Radio.Group>,

                )}
              </FormItem>
              { 
                recallDelayMinuteMap.map((item,index)=>{
                  return (
                    <Form.Item
                      {...formItemLayout}
                      className='noLable'
                      label
                      required={false}
                      key={index}
                    >
                      <span className="ant-form-text"> {getFieldValue('recallDelayType') == 0? '每次间隔' : `第${index+1}次间隔`}</span>
                      {getFieldDecorator(`recallDelayMinuteMap[${index}]`, {
                        validateTrigger: ['onChange', 'onBlur'],
                        rules: [
                          {
                            required: true,
                            whitespace: true,
                            message: "请输入呼叫间隔时间",
                          },
                        ],
                      })(<InputNumber  min={0} max={1440}  placeholder="请输入时间" style={{ width: '30%' }} defaultValue={+item} />)}
                      <span className="ant-form-text"> 分钟</span>
                  </Form.Item>
                  )
                 

                }) 
              }
              <FormItem {...formItemLayout} label="未完成任务处理">
                {getFieldDecorator('recallEvent', {
                  initialValue: recallEvent ,
                })(
                  <Radio.Group>
                    <Radio value={1}>任务顺延</Radio>
                    <Radio value={0}>取消任务</Radio>
                  </Radio.Group>,
                )}
              </FormItem>
            </FormItem> : null}

          <Form.Item {...formItemLayout} label="数据时效性">
            {getFieldDecorator('callCheckType', {
              rules: [{ required: false, message: '数据时效性必填' }],
              initialValue: callCheckType || 0,
            })(
                <Radio.Group>
                  <Radio value={0}>七日内</Radio>
                  <Radio value={1}>当日</Radio>
                </Radio.Group>,
            )}
          </Form.Item>
          {getFieldValue('callCheckType') == 1 ?
              <Form.Item {...formItemLayout} label="请选择时间">
                {getFieldDecorator('callCheckDay', {
                  rules: [{ required: true, message: '请选择时间' }],
                  initialValue: callCheckType === 1 ? this.getMoment(callCheckDay): moment('23:00', 'HH:mm'),
                })(
                    <TimePicker format={"HH:mm"}/>,
                )}
              </Form.Item>
              : null}
          <Form.Item {...formItemLayout} label="接口数据加密">
            {getFieldDecorator('encryptFlag', {
              rules: [{ required: false, message: '接口数据加密必填' }],
              initialValue: encryptFlag,
            })(
                <Radio.Group
                    onChange={this.generateToken}
                >
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>,
            )}
          </Form.Item>
          {getFieldValue('encryptFlag') == 1 ?
              <Form.Item {...formItemLayout} label="加密token">
                {getFieldDecorator('encryptToken', {
                  rules: [{ required: true, message: '数据加密策略必填' }],
                  initialValue: encryptToken,
                })(
                    <Input style={{ width: '80%', marginRight: 10 }} placeholder="请输入加密token" />,
                )}
                <Button onClick={() => { this.getRandomToken() }}>更换</Button>
              </Form.Item>
              : null}

          <Form.Item {...formItemLayout} label="开启任务监控">
            {getFieldDecorator('monitor', {
              // rules: [{ required: true, message: '接口数据加密必填' }],
              initialValue: monitor,
            })(
                <Radio.Group>
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>,
            )}
          </Form.Item>
          <Form.Item {...formItemLayout} label="呼叫前校验">
            {getFieldDecorator('checkBeforeCallout', {
              initialValue: checkBeforeCallout || 0,
            })(
                <Radio.Group>
                  <Radio value={0}>不校验</Radio>
                  <Radio value={1}>校验</Radio>
                </Radio.Group>,
            )}
          </Form.Item>
          {getFieldValue('checkBeforeCallout') === 1 ?
              <Form.Item {...formItemLayout} label="URL">
                {getFieldDecorator('checkUrl', {
                  rules: [{ required: true, message: '校验URL必填' }],
                  initialValue: checkUrl,
                })(
                    <Input style={{ width: '80%', marginRight: 10 }} placeholder="请输入校验URL" />,
                )}
              </Form.Item>
              : null}
            {/* 自定义列 */}
             <CustomColumn 
              onRef={this.onRef}
              timeStr={new Date().getTime()}
              flag={getFieldValue('extColsFlag')}
              initialValue={customizeCols}
             >
              <FormItem style={{marginBottom: 0}}>
                  {getFieldDecorator('extColsFlag', {
                    initialValue: extColsFlag,
                  })(
                    <Switch checkedChildren="开" unCheckedChildren="关" defaultChecked={extColsFlag} size="defalut" />,
                  )}
                </FormItem>
            </CustomColumn>
          {/* </Panel>
          </Collapse> */}
          <div>
            <Row>
              <Col span={4}>
                <h2 style={{ fontSize: 16, textAlign: 'right' }}>TTS语音</h2>
              </Col>
              <Col
                span={4}
                offset={16}
                style={{ color: '#40AEFC', textAlign: 'right', cursor: 'pointer' }}
                onClick={this.audioPlay}>
                <Icon type="play-circle" style={{ marginRight: '8px' }} />
                <span>点击播放</span>
              </Col>
            </Row>
            <Form.Item {...formItemLayout} label="音色">
              {getFieldDecorator('ttsVoiceName', {
                initialValue: ttsVoiceName || toneList[0].id,
                rules: [{ required: true, message: '请选择发音人！' }],
              })(
                <Select
                  placeholder="请选择发音人"
                  disabled={status === 1}
                  value={ttsVoiceName}
                >
                  {toneList && toneList.map(item => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>,
              )}
            </Form.Item>
            <Form.Item {...formItemLayout} label="语速">
              {getFieldDecorator('ttsSpeechRate', {
                initialValue: ttsSpeechRate || 0,
                rules: [{ required: true, message: '请输入语速！' }],
              })(
                <React.Fragment>
                  <Slider
                    min={-500}
                    max={500}
                    onChange={(e) => this.onChangeSetting(e, 'speech')}
                    step={10}
                    value={getFieldValue('ttsSpeechRate')}
                    style={{ width: '300px', display: 'inline-block' }} />
                  <InputNumber
                    placeholder="请输入语速"
                    min={-500}
                    max={500}
                    step={10}
                    style={{ width: '100px', height: '30px', position: 'absolute', right: '-110px', top: '-15px' }}
                    disabled={status === 1}
                    value={getFieldValue('ttsSpeechRate')}
                    onChange={(e) => this.onChangeSetting(e, 'speech')}
                  />
                  <span style={{ position: 'absolute', right: '-160px', top: '-20px' }}>正常 </span>
                </React.Fragment>,
              )}
            </Form.Item>
            <Form.Item {...formItemLayout} label="语调">
              {getFieldDecorator('ttsTone', {
                initialValue: ttsTone || 0,
                rules: [{ required: true, message: '请输入语调！' }],
              })(
                <React.Fragment>
                  <Slider
                    min={-500}
                    max={500}
                    onChange={(e) => this.onChangeSetting(e, 'tone')}
                    step={10}
                    value={getFieldValue('ttsTone')}
                    style={{ width: '300px', display: 'inline-block' }} />
                  <InputNumber
                    placeholder="请输入语调"
                    min={-500}
                    max={500}
                    step={10}
                    precision={0}
                    style={{ width: '100px', height: '30px', position: 'absolute', right: '-110px', top: '-15px' }}
                    disabled={status === 1}
                    value={getFieldValue('ttsTone')}
                    onChange={(e) => this.onChangeSetting(e, 'tone')}
                  />
                  <span style={{ position: 'absolute', right: '-160px', top: '-20px' }}>正常 </span>
                </React.Fragment>,
              )}
            </Form.Item>
            <Form.Item {...formItemLayout} label="音量" style={{ position: 'relative' }}>
              {getFieldDecorator('ttsVolume', {
                initialValue: ttsVolume || ttsVolume === 0 ? ttsVolume : 50,
                rules: [{ required: true, message: '请输入音量！' }],
              })(
                <React.Fragment>
                  <Slider
                    min={0}
                    max={100}
                    onChange={(e) => this.onChangeSetting(e, 'volume')}
                    value={getFieldValue('ttsVolume')}
                    step={1}
                    style={{ width: '300px', display: 'inline-block' }} />
                  <InputNumber
                    placeholder="请输入音量"
                    min={0}
                    max={100}
                    step={1}
                    precision={0}
                    style={{ width: '100px', height: '30px', position: 'absolute', right: '-110px', top: '-15px' }}
                    disabled={status === 1}
                    value={getFieldValue('ttsVolume')}
                    onChange={(e) => this.onChangeSetting(e, 'volume')}
                  />
                  <span style={{ position: 'absolute', right: '-160px', top: '-20px' }}>正常 </span>
                </React.Fragment>,
              )}
            </Form.Item>
          </div>
        </Form>
      </ModalSize>
    );
  }
}

const mapStateToProps = ({ taskManageList }) => ({
  editModalData: taskManageList.editModalData,
  wordStrategyIdOptionList: taskManageList.wordStrategyIdOptionList,
  phoneOptions: taskManageList.phoneOptions,
  workTimeOptions: taskManageList.workTimeOptions,
  searchData: taskManageList.searchData,
  pageStatus: taskManageList.pageStatus,
  templates: taskManageList.templates,
  treeData: taskManageList.treeData,
});

const mapDispatchToProps = dispatch => ({
  listActions: bindActionCreators(tListActions, dispatch),
  SoundMarketActions: bindActionCreators(tSoundMarket, dispatch),
});
const EditModalWrap = Form.create()(EditModal);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditModalWrap);
